import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Layout, Title } from 'common/components/layout';
import { logout } from 'redux/customer/actions';

class Logout extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get(`customerToken`)) {
      props.logout();
    }
  }

  render() {
    const { settings } = this.props;
    if (Cookies.get(`customerToken`)) {
      // don't show while logging out
      return null;
    }
    if (!settings.data) {
      return (
        <Layout title="Logout" loading>
          <Title>Logout</Title>
        </Layout>
      );
    }
    return (
      <Layout title="Logout">
        <Title>Logout</Title>
        <div className="c7-logout-message">
          <p>You have successfully logged out.</p>
          <p>
            <Link to="/profile/login">Return to login.</Link>
          </p>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting
});

export default connect(mapStateToProps, { logout })(Logout);
